/**
 * Shared reservation status colours.
 * `text` = brand / accent (chips, dots, labels)
 * `bg` = contrasting surface for badges & chip text
 */
export const STATUS_COLOURS = {
  Seated: { bg: "#E6F2EC", text: "#095330" },
  Completed: { bg: "#E7F5EC", text: "#0D7F3E" },
  Approved: { bg: "#E8EDFA", text: "#0735B6" },
  Requested: { bg: "#0B2A4A", text: "#7EB4F7" },
  Cancelled: { bg: "#FFECEC", text: "#FE4646" },
  Rejected: { bg: "#EEF1F4", text: "#38485D" },
  Modified: { bg: "#252525", text: "#FABA07" },
};

export const STATUS_LIST = Object.keys(STATUS_COLOURS);

export const DEFAULT_STATUS_COLOUR = STATUS_COLOURS.Requested;

/** Resolve colour for any status label (incl. Expired → Cancelled) */
export function getStatusColour(status) {
  if (!status) return DEFAULT_STATUS_COLOUR;
  if (status === "Expired") return STATUS_COLOURS.Cancelled;
  if (STATUS_COLOURS[status]) return STATUS_COLOURS[status];
  const key = STATUS_LIST.find(
    (k) => k.toLowerCase() === String(status).toLowerCase()
  );
  return (key && STATUS_COLOURS[key]) || DEFAULT_STATUS_COLOUR;
}
